"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Promotion = void 0;
var react_1 = __importDefault(require("react"));
var credit_promotion_svg_1 = __importDefault(require("../../assets/images/credit_promotion.svg"));
var first_auto_promotion_svg_1 = __importDefault(require("../../assets/images/first_auto_promotion.svg"));
var installment_promotion_svg_1 = __importDefault(require("../../assets/images/installment_promotion.svg"));
var prize_promotion_svg_1 = __importDefault(require("../../assets/images/prize_promotion.svg"));
var road_promotion_svg_1 = __importDefault(require("../../assets/images/road_promotion.svg"));
var trade_in_promotion_svg_1 = __importDefault(require("../../assets/images/trade_in_promotion.svg"));
var Promotion_module_scss_1 = __importDefault(require("./Promotion.module.scss"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var selectors_1 = require("../../redux/selectors");
var react_2 = require("swiper/react");
var modules_1 = require("swiper/modules");
var promotionData = [
    {
        title: 'Автокредит',
        description: 'При покупке автомобиля с пробегом в кредит мы предлагаем нашим покупателям скидку до 300 000 ₽. Мы сотрудничаем только с проверенными и крупнейшими банками России.',
        link: 'credit',
        img: credit_promotion_svg_1.default,
    },
    {
        title: 'Трейд-ин',
        description: 'По нашей программе Трейд-ин можно обменять свой старый автомобиль с выгодой до 300 000 ₽. Оценка автомобиля и сопровождение по сделке - абсолютно бесплатны.',
        link: 'exchange',
        img: trade_in_promotion_svg_1.default,
    },
    {
        title: 'Рассрочка',
        description: 'Рассрочка в АЦ "Ю-Авто" - выгодный и удобный способ приобретения автомобиля с пробегом. Срок погашения до 3 лет без первого взноса и переплат. Если же выплата за 3 года не возможна, лучшее решение - автокредит со скидкой до 300 000₽.',
        link: 'installment',
        img: installment_promotion_svg_1.default,
    },
    {
        title: 'Подарок на выбор',
        description: 'При покупке автомобиля в кредит мы предлагаем покупателям подарок на выбор - КАСКО, комплект второй резины или дополнительный аксессуар.',
        img: prize_promotion_svg_1.default,
    },
    {
        title: 'Первый автомобиль',
        description: 'Программа "Первый автомобиль" создана с целью помочь водителям-новичкам приобрести свой первый автомобиль. Программа дарит возможность льготного автокредитования. Водители, участвующие в программе, получают 20% скидку на автомобиль, но только при условии взятия автомобиля в кредит. Это позволяет поддерживать спрос на покупку отечественных автомобилей и авто, собираемых на территории Российской Федерации. Подобная программа была разработана еще в 2009 году и до сих пор успешно функционирует.',
        img: first_auto_promotion_svg_1.default,
    },
    {
        title: 'Оплатим дорогу',
        description: 'Оплатим все денежные расходы на дорогу покупателям из другого региона.',
        img: road_promotion_svg_1.default,
    },
];
var Promotion = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var isSmall = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isSmall;
    var promotionElementHandler = function (payload) {
        dispatch((0, modalSlice_1.openModal)('promotion'));
        dispatch((0, modalSlice_1.setPromotionData)(payload));
    };
    if (isSmall) {
        return (react_1.default.createElement("section", { className: Promotion_module_scss_1.default.promotion },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement(react_2.Swiper, { spaceBetween: 12, slidesPerView: 1.65, pagination: { clickable: true }, modules: [modules_1.Pagination], className: Promotion_module_scss_1.default.promotion__list }, promotionData.map(function (_a) {
                    var title = _a.title, description = _a.description, link = _a.link, img = _a.img;
                    return (react_1.default.createElement(react_2.SwiperSlide, { key: title },
                        react_1.default.createElement("li", { className: Promotion_module_scss_1.default.promotion__item, onClick: function () { return promotionElementHandler({ title: title, description: description, link: link }); } },
                            react_1.default.createElement("h3", { className: Promotion_module_scss_1.default.promotion__title }, title),
                            react_1.default.createElement("img", { loading: "lazy", width: 190, className: Promotion_module_scss_1.default.promotion__img, src: img, alt: "".concat(title, " \u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439") }))));
                })))));
    }
    return (react_1.default.createElement("section", { className: Promotion_module_scss_1.default.promotion },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("ul", { className: Promotion_module_scss_1.default.promotion__list }, promotionData.map(function (_a) {
                var title = _a.title, description = _a.description, link = _a.link, img = _a.img;
                return (react_1.default.createElement("li", { className: Promotion_module_scss_1.default.promotion__item, onClick: function () {
                        return promotionElementHandler({ title: title, description: description, link: link });
                    }, key: title },
                    react_1.default.createElement("h3", { className: Promotion_module_scss_1.default.promotion__title }, title),
                    react_1.default.createElement("img", { loading: "lazy", width: 190, className: Promotion_module_scss_1.default.promotion__img, src: img, alt: "".concat(title, " \u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439") })));
            })))));
};
exports.Promotion = Promotion;
exports.default = exports.Promotion;
